import React from 'react';

const majutus = {
  "majutus.yld.pealkiri": "Majutus",
  "majutus.yld.blokk1": () => (
    <>
      <h2 className="title is-2">Majutus Varbla puhkekülas</h2>
      <p>
        Meil on hubased ja omanäolised mugavustega toad motellis, lisaks
        apartment-tüüpi majutushoone sõpruskondadele või suuremale perele.
      </p>
      <p>
        Motellis leiab ka ruumikaid peretube, mis sobivad ideaalselt lastega
        peredele.
      </p>
      <p>Samuti pakume palkmaju või tagasihoidlike suvekämpingumajakesi.</p>
      <p>
        Suveperioodil on võimalik majutada kuni 142 külalist ja talveperioodil
        kuni 84 külalist.
      </p>
    </>
  ),
  "majutus.motell.pealkiri": "Ranna motell",
  "majutus.motell.kaart.kirjeldus": () => (
    <p>
      Hubane ja omanäoline motell mere kaldal, kus on majutuskohti kuni 52-le
      külalisele.
    </p>
  ),
  "majutus.motell.hinnakiri": () => (
    <>
      <p>Suveperioodil alates 15.06. - 31.08.</p>
      <h5 className="title is-5">E, T, K, N (ühe päeva hind) </h5>
      <p>Tavatuba 1-le 45€</p>
      <p>Tavasviit 2-le 100€</p>
      <p>Sviit saunaga 2-le 110€</p>
      <p>Sviit vanniga 2-le 110€</p>
      <br />
      <h5 className="title is-5">R, L, P (ühe päeva hind) </h5>
      <p>Tavatuba 1-le 55€</p>
      <p>Tavasviit 2-le 110€</p>
      <p>Sviit saunaga 2-le 130€</p>
      <p>Sviit vanniga 2-le 130€</p>
      <br />
      <p>Jaanipäeval ( 22.06. - 25.06.) kehtivad nädalavahetuse hinnad </p>
      <br />
      <p>Hinnad sisaldavad hommikusööki!</p>
      <br />
      <p style={{ color: "red" }}>
        Kui soovid majutust pikemaks perioodiks, rakendame soodushindu.
      </p>
    </>
  ),
  "majutus.motell.blokk1": () => (
    <>
      <p>
        Hubase atmosfääriga kaasaegses motellis on 1-,2-,3- , 4- ja 5- kohalised
        mugavustega toad.
      </p>
      <p>Majas on kokku 19 numbrituba, kuhu mahutab kuni 52 külalist.</p>
      <p>
        Merepoolsetel tubadel on ka rõdu laua ja istumiskohtadega, kus saab
        nautida kaunist vaadet merele.
      </p>
      <p>
        Samas majas asuvas pubisaalis on baar, saab vaadata telekat, lugeda
        ajakirju, mängida piljardit ning noole- ja lauamänge.
      </p>
      <ul>
        <li>1-, 2-, 3-, 4- ja 5- kohalised toad</li>
        <li>WC</li>
        <li>dušš</li>
        <li>voodipesu, saunalina, käterätik seep</li>
        <li>merepoolsetel tubadel rõdu</li>
        <li>
          lõuna- või õhtusöögi soov tuleb teatada juba majutust broneerides!
        </li>
      </ul>
    </>
  ),
  "majutus.ridaelamud.pealkiri": "Ranna ridaelamu",
  "majutus.ridaelamud.kaart.kirjeldus": () => (
    <p>
      4 apartement tüüpi külaliskorterit, mis võimaldavad lahedalt puhata
      suurematel peredel või sõpruskondadel.
    </p>
  ),
  "majutus.ridaelamud.hinnakiri": () => (
    <>
      <h5 className="title is-5">E, T, K, N üks ridaelamuboks 8-le 160€</h5>
      <h5 className="title is-5">R, L, P üks ridaelamuboks 8-le 180€</h5>
      <p style={{ color: "red" }}>
        Kui soovid majutust pikemaks perioodiks, rakendame soodushindu.
      </p>
      <br />
      <p>Soovi korral saab osta lisaks hommikusööki 10.-/pers.</p>
    </>
  ),
  "majutus.ridaelamud.blokk1": () => (
    <>
      <p>Ridaelamus on kokku 4 külaliskorterit 32 magamiskohaga.</p>
      <p>Ideaalne rentida peredele või sõpruskonnale.</p>
      <p>
        Ühe korteri toad on läbi kahe korruse, esimesel korrusel on
        elutuba-köök, wc-dussiruum ja 3-e kitsa voodiga magamistuba, teisel
        korrusel wc-dušširuum, esimeses magamistoas 2 kitsast voodit ja teises
        üks kitsas ja üks lai voodi kahele inimesele.
      </p>
      <ul>
        <li>3 magamistuba 8-le</li>
        <li>mõlemal korrusel wc ja dušš</li>
        <li>puhketuba diivani, laua ja telekaga</li>
        <li>kööginurk (sööginõud, potid-pannid, veekeetja, pliit, külmkapp)</li>
        <li>voodipesud, saunalinad, seep</li>
        <li>terrass, laua ja istumiskohtadega</li>
      </ul>
    </>
  ),
  "majutus.saunamajad.pealkiri": "Saunamajad",
  "majutus.saunamajad.kaart.kirjeldus": () => (
    <p>
      Saunad on iga saunalise kõige suuremad sõbrad. Neil on meil 2 - motelli
      kõrval asuv saunamaja ja rannas Juuli & Aadu saunamaja.
    </p>
  ),
  "majutus.saunamajad.motellisaun.hinnakiri": () => (
    <>
      <p>Majutus motelli saunamajas 25€/inimene</p>
      <br />
      <h5 className="title is-5">
        Saunakasutus 20€/h+ 1.50€ iga saunalise eest
      </h5>
      <h5 className="title is-5">
        E, T, K, N Kogu Motelli saunamaja majutus üheks ööpäevaks 250€
      </h5>
      <h5 className="title is-5">R, L, P 280€</h5>
      <h5 className="title is-5">(sisaldab piiramatut sauna kasutust)</h5>
      <p>Jaanipäeval ( 22.06. - 25.06.) kehtivad nädalavahetuse hinnad </p>
      <br />
      <p style={{ color: "red" }}>
        Kui soovid majutust pikemaks perioodiks, rakendame soodushindu.
      </p>
    </>
  ),
  "majutus.saunamajad.motellisaun.blokk1": () => (
    <>
      <h2 className="title is-2">Motelli Saunamaja</h2>
      <p>
        Motelli kõrval asuva Saunamaja esimesel korrusel asuvad kaminatuba,
        saun, WC ja dušširuum.
      </p>
      <p>
        Hubaseks istumiseks on kaminaruum, mille pehmetel nahast diivanitel ja
        tugitoolidel saab nautida mõnusat olemist ja praksuvat kaminatuld. Sauna
        keris on puuküttega. Koos „Leiliga” mahub saunalavale 5 inimest.
        Värskendama saab end minna nii terrassile kui ka merre. Võimalik on
        lisatasu eest rentida ka kümblustünni/tünnisauna.
      </p>
      <p>
        Väsinud saunalistel on võimalus ööbida Saunamaja teisel korrusel, kuhu
        pääseb mööda õuetreppi. Üleval on kaks tuba kuue laia voodiga.
      </p>
      <ul>
        <li>magamiskohti 12-le (6 laia voodit)</li>
        <li>kaminatuba</li>
        <li>dušširuum</li>
        <li>leiliruum</li>
        <li>WC</li>
        <li>terrass</li>
        <li>külmkapp</li>
      </ul>
    </>
  ),
  "majutus.saunamajad.juuliaadu.hinnakiri": () => (
    <>
      <h5 className="title is-5">
        E, T, K, N kogu maja majutus üheks ööpäevaks 300€
      </h5>
      <h5 className="title is-5">
        R, L, P kogu maja majutus üheks ööpäevaks 350€
      </h5>
      <p>Jaanipäeval ( 22.06. - 25.06.) kehtivad nädalavahetuse hinnad </p>
      <br />
      <p style={{ color: "red" }}>
        Kui soovid majutust pikemaks perioodiks, rakendame soodushindu.
      </p>
    </>
  ),
  "majutus.saunamajad.juuliaadu.blokk1": () => (
    <>
      <h2 className="title is-2">Juuli & Aadu Saunamaja</h2>
      <p>
        Suurepärane võimalus puhata oma seltskonnaga palkmajas, mis asub vaid
        100 meetri kaugusel liivarannast.
      </p>
      <p>
        Maja esimesel korrusel asub avar kaminatuba puhke- ja kööginurgaga, ning
        ruumikas saun, WC ja dušširuum. Maja ees on mõnus terass
        istumiskohtadega.
      </p>
      <p>
        Teisel korrusel asuvad neli magamistuba mahutavad kokku 10 inimest.
        Kahel merepoolsel toal on rõdu koos lauaga. Koridoris asub ühine WC.
      </p>
      <ul>
        <li>10 magamiskohta (2 laia ja 6 kitsast voodit)</li>
        <li>kaminatuba</li>
        <li>puhkenurk</li>
        <li>kööginurk- nõud, potid-pannid, pliit, veekeetja, külmkapp</li>
        <li>saun (puuküttega)</li>
        <li>WC (I ja II korrusel)</li>
        <li>dušširuum</li>
        <li>seep</li>
        <li>voodipesud, saunalinad</li>
        <li>küttepuud</li>
        <li>terrass</li>
        <li>liivarand 100m</li>
      </ul>
    </>
  ),
  "majutus.palkmajad.pealkiri": "Palkmajad",
  "majutus.palkmajad.kaart.kirjeldus": () => (
    <p>
      Ööbimisvõimalus palkmajades on osutunud väga paljude puhkajate lemmikuks.
    </p>
  ),
  "majutus.palkmajad.sissejuhatus": () => (
    <>
      <p>
        Ideaalne võimalus tulla pere või sõpradega puhkama- meri ja kaunis
        liivarand vaid jalutuskäigu kaugusel.
      </p>
      <p>Lähedal on võrkpalliplatsid, liivarannas jalgpalliväravad.</p>
      <p>
        Kolm Puhkemaja on väga hubased ja privaatses kohas. Sees on olemas kõik
        hädavajalik söögi tegemiseks ja lõõgastumiseks.
      </p>
    </>
  ),
  "majutus.palkmajad.taretareke.blokk1": () => (
    <>
      <h2 className="title is-2">Tare-Tareke</h2>
      <p>
        Väikse puhkemaja esimesel korrusel puhketuba, wc-dušš, magamistuba ühe
        laia ja ühe kitsa voodiga, teine magamistuba kahe kitsa voodiga.
      </p>
      <p>Katusealustesse magamiskohtadesse läheb redel puhketoast.</p>
      <p>
        Magamiskohad on lihtsad- madrats põrandal koos voodipesu ja rätikuga,
        magamisasemeid katuseall kokku 6.
      </p>
      <ul>
        <li>11-le</li>
        <li>WC</li>
        <li>dušš</li>
        <li>puhketuba</li>
        <li>nõud, veekeetja, pliit, külmkapp</li>
      </ul>
    </>
  ),
  "majutus.palkmajad.taretareke.hinnakiri": () => (
    <>
      <p style={{ color: "red" }}>01.06. kuni 30.08. on see maja broneeritud</p>
      <br />
      <h5 className="title is-5">
        E, T, K, N kogu maja majutus üheks ööpäevaks 160€
      </h5>
      <h5 className="title is-5">
        R, L, P kogu maja majutus üheks ööpäevaks 180€
      </h5>
      <p>Jaanipäeval ( 22.06. - 25.06.) kehtivad nädalavahetuse hinnad </p>
      <br />
      <p style={{ color: "red" }}>
        Kui soovid majutust pikemaks perioodiks, rakendame soodushindu.
      </p>
    </>
  ),
  "majutus.palkmajad.rannumehe.blokk1": () => (
    <>
      <h2 className="title is-2">Rännumehemaja</h2>
      <p>Rännumehemaja mahutab kokku seitse rändajat.</p>
      <p>
        Esimesel korrusel on üks magamistuba, vannituba ja maja merepoolses
        küljes köök koos puhkenurgaga.{" "}
      </p>
      <p>Teisel korrusel kaks magamistuba ja vannituba.</p>
      <p>
        Igale toale on pandud toredad nimed rännumehe Nipernaadi, seilaja Kihnu
        Jõnni ja multika Oh ja Ah järgi.
      </p>
      <p>100 meetrit otse maja eest laiub liivarand.</p>
      <ul>
        <li>3 magamistuba </li>
        <li>majutus 7-le</li>
        <li>2 WC-d (I ja II korrusel)</li>
        <li>2 dušši (I ja II korrusel)</li>
        <li>puhkenurk</li>
        <li>kööginurk</li>
        <li>
          kohvimasin, veekeetja, pliit, külmkapp, vajalikud söögiriistad ja nõud
        </li>
        <li>kamin</li>
        <li>voodipesu, saunalinad</li>
        <li>seep</li>
        <li>terrass laua ja pinkidega</li>
        <li>liivarand 100m</li>
      </ul>
    </>
  ),
  "majutus.palkmajad.rannumehe.hinnakiri": () => (
    <>
      <h5 className="title is-5">
        E, T, K, N kogu maja majutus üheks ööpäevaks 200€
      </h5>
      <h5 className="title is-5">
        R, L, P kogu maja majutus üheks ööpäevaks 220€
      </h5>
      <p>Jaanipäeval ( 22.06. - 25.06.) kehtivad nädalavahetuse hinnad </p>
      <br />
      <p style={{ color: "red" }}>
        Kui soovid majutust pikemaks perioodiks, rakendame soodushindu.
      </p>
    </>
  ),
  "majutus.palkmajad.pakapiku.blokk1": () => (
    <>
      <h2 className="title is-2">Päkapikumaja</h2>
      <p>Väga õdus majake liivaranna ääres.</p>
      <p>Väljast paistab väike, kuid tegelikult on seest ruumikas.</p>
      <p>Rõdult imeline vaade kaunile mererannale. </p>
      <p>
        Esimesel korrusel üks magamistuba kahe kitsa ja ühe laia voodiga, wc ja
        dušširuum ning suur puhketuba koos kööginurgaga.
      </p>
      <p>
        Teisel korrusel 2 magamistuba, ühes toas 2 laia voodit, teises 1 lai ja
        1 kitsas voodi.
      </p>
      <ul>
        <li>3 magamistuba </li>
        <li>majutus 11-le (3 kitsast ja 4 laia voodit) </li>
        <li>puhketuba</li>
        <li>
          kööginurk- söögiriistad ja nõud, veekeetja, elektripliit, külmkapp
        </li>
        <li>dušširuum</li>
        <li>WC</li>
        <li>seep</li>
        <li>voodipesud, saunalinad</li>
        <li>liivarand 100m</li>
        <li>merevaade</li>
        <li>õues grillimisplats</li>
      </ul>
    </>
  ),
  "majutus.palkmajad.pakapiku.hinnakiri": () => (
    <>
      <h5 className="title is-5">
        E, T, K, N kogu maja majutus üheks ööpäevaks 200€
      </h5>
      <h5 className="title is-5">
        R, L, P kogu maja majutus üheks ööpäevaks 220€
      </h5>
      <p>Jaanipäeval ( 22.06. - 25.06.) kehtivad nädalavahetuse hinnad </p>
      <br />
      <p style={{ color: "red" }}>
        Kui soovid majutust pikemaks perioodiks, rakendame soodushindu.
      </p>
    </>
  ),
  "majutus.kampingud.pealkiri": "Kämpingud",
  "majutus.kampingud.kaart.kirjeldus": () => (
    <p>
      Lihtsad, "spartalikud" kämpingud pakuvad peavarju nii vähenõudlikule
      puhkajale kui ka seljakotiga rännumehele.
    </p>
  ),
  "majutus.kampingud.blokk1": () => (
    <>
      <h2 className="title is-2">Kämpingud</h2>
      <p>
        Soojade ilmade saabudes on võimalus ööbida tagasihoidlikes
        kämpingumajakestes. “Spartalikud”puidust kämpinguid asuvad
        telkimisplatsi küljel, liivaranna vahetus läheduses.
      </p>
      <p>
        Igas majakeses on 2 magamiskohta koos voodipesu ja rätikuga, kuid puudub
        elekter.
      </p>
      <p>Pesemisvõimalus on sadamahoone dušširuumides.</p>
      <ul>
        <li>2 magamisaset</li>
        <li>voodipesud, saunalinad</li>
        <li>WC kasutus eemal</li>
        <li>õues laud ja istumiskohad</li>
      </ul>
      <p>Voodikoht ööpäevaks ühele külalisele 15€.</p>
      <p>(Perioodil 1. juuni- 31. september)</p>
    </>
  ),
};

export default majutus;
